export const state = () => ({
  list: []
})

export const getters = {
  list: (state) => state.list || []
}

export const mutations = {
  setList: (state, payload) => (state.list = payload),

  createItem(state, payload) {
    state.list = [...state.list, payload]
  },

  updateItem(state, payload) {
    const f = state.list.findIndex((item) => item.id == payload.id)

    if (f != -1) {
      state.list = [
        ...state.list.slice(0, f),
        payload,
        ...state.list.slice(f + 1)
      ]
    }
  },

  deleteItem(state, payload) {
    const f = state.list.findIndex((item) => item.id == payload)

    if (f != -1) {
      state.list = [...state.list.slice(0, f), ...state.list.slice(f + 1)]
    }
  }
}

export const actions = {
  fetch({ commit }, payload) {
    return this.$api
      .get("/gallery/list", {
        params: payload
      })
      .then((res) => {
        if (res && res.data) {
          commit("setList", res.data && res.data.results)
          return res.data
        }

        return []
      })
      .catch((err) => {
        console.log(err)
        return []
      })
  },

  detail(_, payload) {
    return this.$api
      .get("/gallery/detail/" + payload)
      .then((res) => {
        if (res && res.data) {
          return res.data
        }

        return {}
      })
      .catch((err) => {
        console.log(err)
        return {}
      })
  },
  createItemAction(_, payload) {
    return this.$api
      .post("/gallery/create", payload.data)
      .then((res) => {
        // commit("createItem", res.data || []);
        return (res && res.data) || {}
      })
      .catch((err) => {
        console.log(err)
        return -1
      })
  },

  updateItemAction(_, payload) {
    return this.$api
      .put("/gallery/update/" + payload.id, payload.data)
      .then((res) => {
        // commit("updateItem", res.data || []);
        return res
      })
      .catch((err) => {
        console.log(err)
        return -1
      })
  },

  removeItemAction(_, payload) {
    return this.$api
      .delete("/gallery/delete/" + payload)
      .then((res) => !!(res && res.status >= 200))
      .catch((err) => {
        console.log(err)
        return false
      })
  },

  ///
  /// gallery file
  ///

  fileCreate(_, fileItem) {
    const f = new FormData()

    Object.keys(fileItem).forEach((item) => f.append(item, fileItem[item]))

    return this.$api
      .post("/gallery/file/create", f)
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.error(err)
      })
  },

  fileUpdate(_, fileItem) {
    if (!fileItem) return

    const f = new FormData()

    Object.keys(fileItem).forEach((item) => f.append(item, fileItem[item]))

    return this.$api
      .put("/gallery/file/update/" + fileItem.id || -1, f)
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.error(err)
      })
  },

  fileDelete(_, fileId) {
    return this.$api
      .delete("/gallery/file/delete/" + fileId)
      .then((res) => {
        console.log(res)
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
